<div class="panelFondo" style="height: 100%">
  <div class="row">
    <div class="contenedorLogin center-xs col-xs-12 col-sm-10 col-md-8">
      <div style="text-align: right">
        <img class="logoLogin" src="./assets/logos/Sysman.png" alt="logo Sysman" i18n-alt />
      </div>
      <form (ngSubmit)="accionbutton()">
        @switch (estado) {
          @case ('usuario') {
            <p class="titulo-inicio">{{ 'general.login.lb_5_iniciarsesion' | translate }}</p>
            <mat-form-field appearance="outline" i18n-appearance>
              <mat-label class="labelInput">{{ 'general.login.lb_1_usuario' | translate }}</mat-label>
              <input
                class="full-width labelNormal"
                #txtU
                id="txtU"
                maxlength="30"
                matInput
                [(ngModel)]="txtUsuario"
                [ngModelOptions]="{ standalone: true }"
              />
              <mat-hint align="end" i18n-align>{{ txtU.value.length || 0 }}/30</mat-hint>
            </mat-form-field>
          }
          @case ('compania') {
            <p class="titulo-inicio">
              <button mat-icon-button type="button" [matTooltip]="'Volver'" (click)="return()">
                <mat-icon i18n>keyboard_backspace</mat-icon>
              </button>
              <a class="Usuario">{{ nombreusuario }}</a>
            </p>
            <app-combo
              [url]="combocompanias_url"
              [claveSeleccion]="combocompanias_claveseleccion"
              [tipo]="'C'"
              id="id"
              label="{{ 'general.login.lb_4_compania' | translate }}"
              [parametros]="combocompanias_params"
              campoVisible="nombre"
              i18n-campoVisible
              (alSeleccionar)="combocompanias($event)"
            >
            </app-combo>
          }
          @case ('contrasena') {
            <p class="titulo-inicio">
              <button mat-icon-button type="button" [matTooltip]="'Volver'" (click)="return()">
                <mat-icon i18n>keyboard_backspace</mat-icon>
              </button>
              <a class="Usuario">{{ nombreusuario }}</a>
            </p>
            <mat-form-field appearance="outline" i18n-appearance>
              <mat-label class="labelInput">{{ 'general.login.lb_2_contrasena' | translate }}</mat-label>
              <input
                class="full-width labelNormal"
                #txtP
                matInput
                id="txtP"
                maxlength="30"
                [type]="ocultarContrasena ? 'password' : 'text'"
                [(ngModel)]="txtPass"
                [ngModelOptions]="{ standalone: true }"
              />
              <mat-hint align="end" i18n-align>{{ txtP.value.length || 0 }}/30</mat-hint>

              <button
                mat-icon-button
                matSuffix
                (click)="ocultarContrasena = !ocultarContrasena"
                [attr.aria-label]="'ocultar contraseña'"
                [attr.aria-pressed]="ocultarContrasena"
              >
                <mat-icon>{{ ocultarContrasena ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
            </mat-form-field>
          }
          @default {
            <p class="titulo-inicio">{{ 'general.login.lb_5_iniciarsesion' | translate }}</p>
            <mat-form-field appearance="outline" i18n-appearance>
              <mat-label class="labelInput">{{ 'general.login.lb_1_usuario' | translate }}</mat-label>
              <input
                class="full-width labelNormal"
                #txtU
                id="txtU"
                maxlength="30"
                matInput
                [(ngModel)]="txtUsuario"
                [ngModelOptions]="{ standalone: true }"
              />
              <mat-hint align="end" i18n-align>{{ txtU.value.length || 0 }}/30</mat-hint>
            </mat-form-field>
          }
        }

        @if (estado !== 'contrasena') {
          <button class="btnlogin" type="submit" mat-raised-button>
            {{ 'general.login.lb_3_siguiente' | translate }}
          </button>
        } @else {
          <button class="btnlogin" type="submit" mat-raised-button>
            {{ 'general.login.lb_5_iniciarsesion' | translate }}
          </button>
        }
      </form>
    </div>
  </div>
</div>
